import { z } from "zod";

import { pipelineRuleSchema } from "./pipeline-rule";

export const ruleEngineConfigurationSchema = z.object({
	entityId: z.string(),
	version: z.number(),
	initialVersion: z.number(),
	lastUpdated: z.string(),
	tenantId: z.string(),
	rules: z.array(pipelineRuleSchema),
	scope: z.string().nullish(),
});
export type RuleEngineConfiguration = z.infer<typeof ruleEngineConfigurationSchema>;
